import { FaqStatusPill } from "../faq-list/FaqStatusPill";

interface Props {
  showOnFaqPage: boolean;
  onChange: (next: boolean) => void;
}

/**
 * Right-rail toggle that controls whether this FAQ appears on the
 * public /faq page. Hidden FAQs still exist and can be embedded in
 * landing pages — the toggle only governs the global list.
 */
export function VisibilityPanel({ showOnFaqPage, onChange }: Props) {
  return (
    <div className="shadow-card rounded-lg bg-paper-hi">
      <div className="hair-b border-b flex items-center justify-between px-4 py-3">
        <h3 className="text-[13px] font-semibold">Visibility</h3>
        <FaqStatusPill showOnFaqPage={showOnFaqPage} />
      </div>
      <div className="p-3">
        <button
          type="button"
          role="switch"
          aria-checked={showOnFaqPage}
          onClick={() => onChange(!showOnFaqPage)}
          className="flex w-full items-center justify-between gap-2 rounded-md px-3 py-2 text-left transition hover:bg-paper-2"
        >
          <span className="min-w-0 flex-1">
            <div className="text-[13px] font-medium text-ink-2">
              {showOnFaqPage ? "Show on FAQ page" : "Hide from FAQ page"}
            </div>
            <div className="mt-0.5 text-[11.5px] text-ink-4">
              {showOnFaqPage
                ? "Visitors can find this at /faq."
                : "Available only when embedded in a landing page."}
            </div>
          </span>
          <Toggle on={showOnFaqPage} />
        </button>
      </div>
    </div>
  );
}

function Toggle({ on }: { on: boolean }) {
  return (
    <span
      aria-hidden
      className={`relative inline-flex h-5 w-9 flex-shrink-0 items-center rounded-full transition-colors ${
        on ? "bg-tide" : "bg-ink-6"
      }`}
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full bg-paper-hi shadow-sm transition-transform ${
          on ? "translate-x-[18px]" : "translate-x-0.5"
        }`}
      />
    </span>
  );
}
